module.exports = __webpack_public_path__ + "static/img/102756.88e9be7b.png";